import { lazy } from 'react';
const HomePage = lazy(() => import('../../pages/HomeComponent'));
const NotFoundPage = lazy(() => import('../../pages/NotFoundPage'));

const defaultRoutes = [
  {
    title: 'Home',
    path: '/',
    index: true,
    component: HomePage,
    isPrivate: false,
  },
  {
    title: 'Ups!',
    path: '*',
    component: NotFoundPage,
    isPrivate: false,
  },
];

export default defaultRoutes;
